<template>
  <div style="overflow: hidden; width: 560px">
    <div class="field-group q-mt-sm">
      <div class="field-group__row no-wrap items-baseline justify-between">
        <div class="bold-name q-mr-xs">{{ $t('invoice_type') }}:</div>
        <q-select
          flat
          v-model="theModel.billType"
          style="min-width: 150px; padding: 0 !important"
          class="thin-input"
          dropdown-icon="expand_more"
          fill-input
          :bottom-slots="false"
          :disable="incomingOnly"
          dense
          outlined
          input-debounce="500"
          emit-value
          map-options
          option-label="Name"
          option-value="Id"
          ref="from_select"
          :options="typeOptions"
        />
      </div>
    </div>

    <div class="field-group q-mt-sm">
      <div class="field-group__row no-wrap items-baseline justify-between">
        <div class="bold-name q-mr-xs">{{ $t('amount') }}:</div>
        <native-input
          ref="amount_input"
          style="min-width: 150px"
          v-model="theModel.billAmount"
          input-type="number"
          :edit-on-click="true"
          :show-border="true"
          :min-number-value="0"
        />
      </div>
    </div>

    <div v-if="theModel.billType === 0" class="field-group q-mt-sm">
      <div class="field-group__row no-wrap items-baseline justify-between">
        <div class="bold-name q-mr-xs">{{ $t('number') }}:</div>
        <native-input
          style="min-width: 150px"
          ref="number_input"
          :show-border="true"
          :edit-on-click="true"
          v-model="theModel.billNumber"
        />
      </div>
    </div>

    <div class="field-group q-mt-sm">
      <div class="bold-name q-mr-xs q-mt-xs">{{ $t('comment') }}:</div>
      <native-input
        style="max-width: 100%; min-width: 100%"
        ref="comment_input"
        v-model="theModel.billNote"
        :edit-on-click="true"
        :show-border="true"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import _ from "lodash";
import NativeInput from "@/components/common/basic/NativeInput.vue";
import { BillType } from "@/models/etc/types";

export interface BillStructure {
  billType: BillType;
  billAmount: number;
  billNumber: string;
  // billDate: Date;
  billNote: string;
}

@Component({
  components: { NativeInput },
  emits: ["close", "update:modelValue"],
})
export default class BillCreateForm extends Vue {
  @Prop({ default: undefined })
  modelValue!: BillStructure;
  @Prop({ default: true })
  incomingOnly!: boolean;

  created() {}

  mounted() {}

  get theModel() {
    return this.modelValue;
  }

  get textInputOptions() {
    return {
      enterSubmit: true,
      tabSubmit: true,
      openMenu: "toggle",
      rangeSeparator: "-",
      selectOnFocus: false,
      format: "dd.MM.yyyy",
    };
  }

  @Watch("modelValue", { deep: true })
  model_changed(new_value: BillStructure) {
    this.$emit("update:modelValue", new_value);
  }

  formatDate(date: Date): string {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${String(day).padStart(2, "0")}.${String(month).padStart(
      2,
      "0",
    )}.${year}`;
  }

  get typeOptions() {
    return [
      {
        Name: this.$t('incoming'),
        Id: BillType.Incoming,
      },
      {
        Name: this.$t('outgoing'),
        Id: BillType.Outgoing,
      },
    ];
  }

  close() {
    this.$emit("close", null);
  }
}
</script>

<style lang="scss"></style>
